import { Box, Grid, Typography, Radio, Checkbox, RadioProps, CheckboxProps, Theme } from '@mui/material';
import { WishlistButton, WishlistButtonProps } from '../wishlist-button/WishlistButton';
import type { SystemStyleObject } from '@mui/system';
import { wishlistItemCardStyles } from './styles';
import _ from 'lodash';

interface WishlistItemCardProps extends WishlistButtonProps {
  isSubHeadingFirst?: boolean;
  imageUrl?: string;
  onImageLoadError?: React.ReactEventHandler<HTMLImageElement>;
  title: string;
  subHeading?: string;
  info: string;
  itemFormType?: 'checkbox' | 'radio';
  FieldProps?: RadioProps | CheckboxProps;
  hideWishlistBtn?: boolean;
  hideField?: boolean;
  sx?: SystemStyleObject<Theme>;
}
export const WishlistItemCard: React.FC<WishlistItemCardProps> = ({
  isSubHeadingFirst,
  imageUrl,
  title,
  onImageLoadError,
  subHeading,
  info,
  itemFormType = 'checkbox',
  FieldProps,
  hideWishlistBtn,
  children,
  hideField,
  sx,
  ...wishlistButtonProps
}) => {
  const renderSubHeading = (): React.ReactNode => {
    if (!subHeading) return null;
    return (
      <Box sx={{ mb: 0.25 }}>
        <Typography variant="medium" fontWeight="Medium" color="secondary">
          {subHeading}
        </Typography>
      </Box>
    );
  };

  const FormComponent = itemFormType === 'radio' ? Radio : Checkbox;
  return (
    <Box component="label" sx={_.compact([wishlistItemCardStyles.card, sx])}>
      {(!hideField || !hideWishlistBtn) && (
        <Box>
          <Grid container spacing={1} justifyContent="space-between" alignItems="center">
            {!hideField && (
              <Grid item>
                <Box sx={{ bgcolor: 'grey.50', borderRadius: '0.5rem' }}>
                  <FormComponent
                    sx={{ borderRadius: 'inherit' }}
                    disabled={wishlistButtonProps.isDisabled}
                    value={wishlistButtonProps.moduleId}
                    {...FieldProps}
                  />
                </Box>
              </Grid>
            )}
            {!hideWishlistBtn && (
              <Grid item>
                <WishlistButton {...wishlistButtonProps} />
              </Grid>
            )}
          </Grid>
        </Box>
      )}
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2.5}>
          {imageUrl && (
            <Grid item>
              <Box component="img" onError={onImageLoadError} sx={wishlistItemCardStyles.img} src={imageUrl} />
            </Grid>
          )}
          <Grid item xs>
            {isSubHeadingFirst && renderSubHeading()}
            <Typography variant="h6" sx={{ mb: 1 }}>
              {title}
            </Typography>
            {!isSubHeadingFirst && renderSubHeading()}
            <Typography variant="medium" color="secondary">
              {info}
            </Typography>
          </Grid>
        </Grid>
        {children}
      </Box>
    </Box>
  );
};
